import React, { createContext, useContext, useRef, useState } from 'react'

const PlayerContext = createContext({ play: () => {}, isPlaying: false })

export function Player({
  children,
  className = '',
  poster,
  src,
  autoPlay = false,
  muted = false,
  playsInline = false,
  controls = true,
  loop = false,
  preload = 'metadata',
  style,
  ...rest
}) {
  const videoRef = useRef(null)
  const [isPlaying, setIsPlaying] = useState(Boolean(autoPlay))

  const play = () => {
    const video = videoRef.current
    if (!video) return

    const playPromise = video.play()
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(() => {
        // Browser autoplay restrictions can reject play(); the native controls
        // remain visible so the user can still start the video manually.
      })
    }
  }

  return (
    <div className={`video-react ${className}`.trim()} style={{ position: 'relative', ...style }} {...rest}>
      <video
        ref={videoRef}
        className="video-react-video"
        poster={poster || undefined}
        src={src || undefined}
        autoPlay={autoPlay}
        muted={muted}
        playsInline={playsInline}
        controls={controls}
        loop={loop}
        preload={preload}
        onPlay={() => setIsPlaying(true)}
        onPause={() => setIsPlaying(false)}
        style={{ width: '100%', height: '100%', display: 'block', objectFit: 'cover' }}
      />
      <PlayerContext.Provider value={{ play, isPlaying }}>
        {children}
      </PlayerContext.Provider>
    </div>
  )
}

export function BigPlayButton({ position = 'center', className = '', ...rest }) {
  const { play, isPlaying } = useContext(PlayerContext)

  if (isPlaying) return null

  return (
    <button
      type="button"
      aria-label="Play video"
      className={`video-react-big-play-button video-react-big-play-button-${position} ${className}`.trim()}
      onClick={play}
      {...rest}
      style={{
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        width: 72,
        height: 72,
        borderRadius: '999px',
        border: '2px solid rgba(255,255,255,0.9)',
        background: 'rgba(0,0,0,0.45)',
        color: '#fff',
        cursor: 'pointer',
        boxShadow: '0 8px 24px rgba(0,0,0,0.25)',
        ...rest.style,
      }}
    >
      <span
        aria-hidden="true"
        style={{
          display: 'block',
          marginLeft: 6,
          width: 0,
          height: 0,
          borderTop: '16px solid transparent',
          borderBottom: '16px solid transparent',
          borderLeft: '24px solid currentColor',
        }}
      />
    </button>
  )
}
